import { render, staticRenderFns } from "./agreement.vue?vue&type=template&id=08c8b0c6&scoped=true&"
import script from "./agreement.vue?vue&type=script&lang=js&"
export * from "./agreement.vue?vue&type=script&lang=js&"
import style0 from "./agreement.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./agreement.vue?vue&type=style&index=1&id=08c8b0c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c8b0c6",
  null
  
)

export default component.exports